import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import { setStepIndex, setRun } from 'store/entities/tour/actions'
import TourTooltip from './TourTooltip'

const mapDispatchToProps = {
  setStepIndex,
  setRun,
}

export default connect(null, mapDispatchToProps)(withTranslation()(TourTooltip))
